import { useIsConnectEnabled } from "@/react/hooks/useIsConnectEnabled";
import { ChatIcon } from "@circle-react/components/Chat/ChatIcon";
import { usePunditUserContext } from "@circle-react/contexts";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import {
  useAnyHoverMediaQuery,
  useSmScreenMediaQuery,
} from "@circle-react/hooks/useMediaQuery";
import type { CommunityMember } from "@circle-react/types";

export interface MemberActionsProps {
  communityMember: CommunityMember;
}

export const MemberActions = ({ communityMember }: MemberActionsProps) => {
  const { currentCommunityMember } = usePunditUserContext();
  const canHover = useAnyHoverMediaQuery();

  const isConnectEnabled = useIsConnectEnabled();

  const isCurrentUser = currentCommunityMember?.id === communityMember.id;
  const isSmScreen = useSmScreenMediaQuery();

  const shouldShowChatButton =
    !isCurrentUser &&
    communityMember.messaging_enabled &&
    currentCommunityMember?.messaging_enabled;

  return (
    <div
      className={classNames(
        "text-default hover:text-default flex items-center gap-x-1",
        canHover && "invisible group-hover:visible",
      )}
    >
      {shouldShowChatButton && !isSmScreen && !isConnectEnabled && (
        <ChatIcon showIcon communityMemberId={communityMember.id} />
      )}
    </div>
  );
};
